import { jsonHeaders$ } from './headers';
import { filter, switchMap } from 'rxjs/operators';
import { ajax } from 'rxjs/ajax';
import { AuditEventType } from 'types/track/AuditEventType';

export const trackingService = {
    trackCustomEvent$: (event: {
        eventType: AuditEventType;
        otherProperties?: Record<string, any>;
    }) =>
        jsonHeaders$.pipe(
            filter(headers => !!headers),
            switchMap((headers) =>
                ajax({
                    method: 'post',
                    url: `api/track/TrackCustomEvent`,
                    headers,
                    body: event,
                })
            )
        ),
};